<template>
  <div>
    <Head title="Reports" />
    <h1 class="mb-8 text-3xl font-bold">Reports</h1>
    <div class="my-5">
      <Datepicker v-model="form.date" class="mr-4 w-full max-w-md" range :enable-time-picker="false" :partial-range="false" />
    </div>
    <h3 v-if="role === 'manager'" class="my-5 text-lg">Support Team</h3>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-1 pt-6 px-3">User</th>
            <th class="pb-1 pt-6 px-3">Pending Orders</th>
            <th class="pb-1 pt-6 px-3">Orders on Hold</th>
            <th class="pb-1 pt-6 px-3 text-red-500">SLA Breaches</th>
            <th class="pb-1 pt-6 px-3">Orders Confirmed</th>
            <th class="pb-2 pt-6 px-3">Orders Cancelled</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in report.data" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <div class="px-6 py-3">{{ user.name }}</div>
            </td>
            <td class="border-t">
              <div class="px-6 py-3">{{ user.pending }}</div>
            </td>
            <td class="border-t">
              <div class="px-6 py-3">{{ user.hold }}</div>
            </td>
            <td class="border-t">
              <div v-if="user.sla_breaches > 0" class="px-6 py-3 text-red-500">{{ user.sla_breaches }}</div>
              <div v-else class="px-6 py-3">{{ user.sla_breaches }}</div>
            </td>
            <td class="border-t">
              <div class="px-6 py-3">{{ user.confirmed }}</div>
            </td>
            <td class="border-t">
              <div class="px-6 py-3">{{ user.cancelled }}</div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="hover:bg-gray-100 focus-within:bg-gray-100 font-bold">
            <td class="border-t">
              <div class="px-6 py-3">Total</div>
            </td>
            <td class="border-t">
              <div class="px-6 py-3">{{ total('pending') }}</div>
            </td>
            <td class="border-t">
              <div class="px-6 py-3">{{ total('hold') }}</div>
            </td>
            <td class="border-t">
              <div class="px-6 py-3 text-red-500">{{ total('sla_breaches') }}</div>
            </td>
            <td class="border-t">
              <div class="px-6 py-3">{{ total('confirmed') }}</div>
            </td>
            <td class="border-t">
              <div class="px-6 py-3">{{ total('cancelled') }}</div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <hr />
    <div style="border-top: 1px solid rgb(0 0 0 / 9%)" class="my-5"></div>
    <h3 v-if="role === 'manager'" class="my-5 text-lg">Dispatch Team</h3>
    <h3 class="text-lg text-red-500 my-5 font-bold"> {{dispatch_report.sla_breaches}} Total SLA Breaches</h3>
    <div v-if="role === 'manager'" class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
          <tr class="text-left font-bold">
            <th class="pb-1 pt-6 px-3">User</th>
            <th class="pb-1 pt-6 px-3">Dispatched Orders</th>
            <th class="pb-1 pt-6 px-3">Cancelled Orders</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="user in dispatch_report.data" class="hover:bg-gray-100 focus-within:bg-gray-100">
            <td class="border-t">
              <div class="px-6 py-3">{{ user.name }}</div>
            </td>
            <td class="border-t">
              <div class="px-6 py-3">{{ user.dispatched }}</div>
            </td>
            <td class="border-t">
              <div class="px-6 py-3">{{ user.cancelled }}</div>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="hover:bg-gray-100 focus-within:bg-gray-100 font-bold">
            <td class="border-t">
              <div class="px-6 py-3">Total</div>
            </td>
            <td class="border-t">
              <div class="px-6 py-3">{{ total_dispatched('dispatched') }}</div>
            </td>
            <td class="border-t">
              <div class="px-6 py-3">{{ total_dispatched('cancelled') }}</div>
            </td>
          </tr>
        </tfoot>
      </table>
    </div>

    <hr />
    <div style="border-top: 1px solid rgb(0 0 0 / 9%)" class="my-5"></div>
    <h3 v-if="role === 'manager'" class="my-5 text-lg">Order Cancellation Analysis</h3>
    <h3 class="text-lg text-red-500 my-5 font-bold"> {{cancel_report.total}} Total Cancellations</h3>
    <div v-if="role === 'manager'" class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <thead>
        <tr class="text-left font-bold">
          <th class="pb-1 pt-6 px-3">User</th>
          <th class="pb-1 pt-6 px-3">Out of station</th>
          <th class="pb-1 pt-6 px-3">Mistake</th>
          <th class="pb-1 pt-6 px-3">Custom</th>
          <th class="pb-1 pt-6 px-3">NSA</th>
          <th class="pb-1 pt-6 px-3">Mailed</th>
          <th class="pb-1 pt-6 px-3">Request</th>
          <th class="pb-1 pt-6 px-3">Price Issue</th>
          <th class="pb-1 pt-6 px-3">Prepaid</th>
          <th class="pb-1 pt-6 px-3">Other</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="user in cancel_report.list" class="hover:bg-gray-100 focus-within:bg-gray-100">
          <td class="border-t">
            <div class="px-6 py-3">{{ user.name }}</div>
          </td>
          <td class="border-t">
            <div class="px-6 py-3">{{ user.out_of_station ?? 0 }}</div>
          </td>
          <td class="border-t">
            <div class="px-6 py-3">{{ user.order_by_mistake ?? 0 }}</div>
          </td>
          <td class="border-t">
            <div class="px-6 py-3">{{ user.custom_order  ?? 0 }}</div>
          </td>
          <td class="border-t">
            <div class="px-6 py-3">{{ user.nsa  ?? 0 }}</div>
          </td>
          <td class="border-t">
            <div class="px-6 py-3">{{ user.mailed ?? 0 }}</div>
          </td>
          <td class="border-t">
            <div class="px-6 py-3">{{ user.cancellation_request ?? 0 }}</div>
          </td>
          <td class="border-t">
            <div class="px-6 py-3">{{ user.price_issue ?? 0 }}</div>
          </td>
          <td class="border-t">
            <div class="px-6 py-3">{{ user.converted_prepaid ?? 0 }}</div>
          </td>
          <td class="border-t">
            <div class="px-6 py-3">{{ user.other ?? 0 }}</div>
          </td>
        </tr>
        </tbody>
        <tfoot>
        <tr class="hover:bg-gray-100 focus-within:bg-gray-100 font-bold">
          <td class="border-t">
            <div class="px-6 py-3"></div>
          </td>
          <td class="border-t">
            <div class="px-6 py-3">{{ cancel_report.totals.out_of_station ?? 0 }}</div>
          </td>
          <td class="border-t">
            <div class="px-6 py-3">{{ cancel_report.totals.order_by_mistake ?? 0 }}</div>
          </td>
          <td class="border-t">
            <div class="px-6 py-3">{{ cancel_report.totals.custom_order  ?? 0 }}</div>
          </td>
          <td class="border-t">
            <div class="px-6 py-3">{{ cancel_report.totals.nsa  ?? 0 }}</div>
          </td>
          <td class="border-t">
            <div class="px-6 py-3">{{ cancel_report.totals.mailed ?? 0 }}</div>
          </td>
          <td class="border-t">
            <div class="px-6 py-3">{{ cancel_report.totals.cancellation_request ?? 0 }}</div>
          </td>
          <td class="border-t">
            <div class="px-6 py-3">{{ cancel_report.totals.price_issue ?? 0 }}</div>
          </td>
          <td class="border-t">
            <div class="px-6 py-3">{{ cancel_report.totals.converted_prepaid ?? 0 }}</div>
          </td>
          <td class="border-t">
            <div class="px-6 py-3">{{ cancel_report.totals.other ?? 0 }}</div>
          </td>
        </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import { Head } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import Datepicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { startOfDay, endOfDay } from 'date-fns'
import throttle from 'lodash/throttle'
import pickBy from 'lodash/pickBy'

export default {
  components: {
    Head,
    Datepicker,
  },
  layout: Layout,
  props: {
    filters: Object,
    report: Object,
    role: String,
    dispatch_report: Object,
    cancel_report: Object,
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/reports', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  data() {
    return {
      form: {
        date: this.filters.date ?? [startOfDay(new Date()), endOfDay(new Date())],
      },
    }
  },
  methods: {
    total (status) {
      let total = 0
      this.report.data.forEach((item) => {
        total += item[status]
      })

      return total
    },
    total_dispatched (status) {
      let total = 0
      this.dispatch_report.data.forEach((item) => {
        total += item[status]
      })

      return total
    },
  },
}
</script>
